"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TPB = void 0;
const collectionName_1 = require("./collectionName");
const TpbUrlCoder_1 = require("./TpbUrlCoder");
var TPB;
(function (TPB) {
    // 予約ステータス
    let Status;
    (function (Status) {
        Status["Initial"] = "initial";
        Status["Candidate"] = "candidate";
        Status["Confirmed"] = "confirmed"; // 確定済み
    })(Status = TPB.Status || (TPB.Status = {}));
    let AttendeeRole;
    (function (AttendeeRole) {
        AttendeeRole["Organizer"] = "organizer";
        AttendeeRole["Selector"] = "selector";
        AttendeeRole["Confirmor"] = "confirmor";
    })(AttendeeRole = TPB.AttendeeRole || (TPB.AttendeeRole = {}));
    // CandidatePeriodのステータス
    let CandidatePeriodStatus;
    (function (CandidatePeriodStatus) {
        CandidatePeriodStatus["Available"] = "available";
        CandidatePeriodStatus["Rejected"] = "rejected";
        CandidatePeriodStatus["confirmed"] = "confirmed";
    })(CandidatePeriodStatus = TPB.CandidatePeriodStatus || (TPB.CandidatePeriodStatus = {}));
    // 調整アクション
    let ActionType;
    (function (ActionType) {
        ActionType["Create"] = "create";
        ActionType["SelectCandidate"] = "select_candidates";
        ActionType["Confirm"] = "confirm";
        ActionType["Reset"] = "reset";
    })(ActionType = TPB.ActionType || (TPB.ActionType = {}));
    TPB.CollectionName = collectionName_1.CollectionName;
    TPB.UrlCoder = TpbUrlCoder_1.TPBURLCoder;
})(TPB = exports.TPB || (exports.TPB = {}));
//# sourceMappingURL=index.js.map